import { jsx as _jsx } from "react/jsx-runtime";
import cn from 'classnames';
import styles from './LoadingIcon.module.scss';
export const LoadingIcon = ({ variant = 'primary', size = 'medium', }) => (_jsx("div", { className: cn(styles.loading, styles[variant], styles[size]) }));
